import { queryOptions, useQuery, QueryClient } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getTranslationsRequest } from "lib/api/language";

export const languageKeys = {
    all: ["language"] as const,
    translations: () => [...languageKeys.all, "translations"] as const,
    translation: (languageCode: string) => [...languageKeys.translations(), languageCode] as const,
};

export const translationQueryOptions = (languageCode: string | undefined) =>
    queryOptions<HashMap<string>>({
        queryKey: languageCode ? languageKeys.translation(languageCode) : languageKeys.translation("__missing__"),
        queryFn: () => {
            if (!languageCode) {
                return Promise.reject(new Error("Missing language code"));
            }

            return parseResponse<HashMap<string>>(getTranslationsRequest(languageCode));
        },
        enabled: Boolean(languageCode),
    });

export const useTranslations = (languageCode: string | undefined) => useQuery(translationQueryOptions(languageCode));

export const prefetchTranslations = (queryClient: QueryClient, languageCode: string) =>
    queryClient.prefetchQuery(translationQueryOptions(languageCode));
